module.exports = __webpack_public_path__ + "img/252.a7270cd4.png";